import React, { useState } from "react";
import { Loader } from "../../Components/Loader";
import { ToastMsg } from "../../Components/ToastMsg";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../api"; // <-- make sure you have this API

const Login = () => {
  const navigate = useNavigate();
  const [formInput, setFormInput] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormInput((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!formInput.email || !formInput.password) {
      return ToastMsg("Email & Password are required", "error");
    }

    try {
      setLoading(true);
      const res = await loginUser(formInput);
      
      setLoading(false);
      ToastMsg(res?.data?.message || "Login Successful", "success");

      // Save token if returned
      if (res?.data?.data?.access_token) {
        localStorage.setItem("authToken", res?.data?.data?.access_token);
        localStorage.setItem("user_details",JSON.stringify(res?.data?.data?.user))
      }
      console.log("pppppppp",res?.data?.data?.access_token)
     window.location.href= "/dashboard"
      
    } catch (err) {
      setLoading(false);
      console.error("❌ Login failed:", err);
      ToastMsg(err?.response?.data?.message || "Login Failed", "error");
    }
  };

  const inputClass =
    "block w-full text-[#fff] rounded-md bg-[#1E1E1E] px-3 py-4 text-sm placeholder-[#454545] outline-none border border-[#333] focus:border-[#F3B753]";

  const labelClass =
    "absolute -top-2 left-2 inline-block rounded-lg bg-[#161616] px-1 text-xs font-medium text-[#868686]";

  const renderFloatingInput = (name, label, placeholder, type = "text") => (
    <div className="relative mt-6">
      <label htmlFor={name} className={labelClass}>
        {label}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        className={inputClass}
        value={formInput[name]}
        onChange={handleInput}
      />
    </div>
  );

  if (loading) return <Loader />;

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#161616]">
      <div className="w-full max-w-md bg-[#1E1E1E] rounded-xl p-8 shadow-md">
        <h2 className="text-2xl font-semibold text-white mb-6 text-center">
          Login
        </h2>

        <form onSubmit={onSubmit}>
          {renderFloatingInput("email", "Email ID", "Enter Email ID")}
          {renderFloatingInput(
            "password",
            "Password",
            "Enter Password",
            "password"
          )}

          <button
            type="submit"
            className="mt-8 w-full bg-[#F3B753] text-black font-medium py-3 rounded-lg text-sm hover:bg-[#e3a840]"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
